/* global axios */
import ApiClient from './ApiClient';

class BookmarksAPI extends ApiClient {
  constructor() {
    super('bookmarks', { accountScoped: true });
  }

  getAll(params = {}) {
    return axios.get(this.url, { params });
  }

  get(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(formData) {
    return axios.post(this.url, formData);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new BookmarksAPI();
